import { lazy } from "react"
import { RouteObject } from "react-router"

const SettleUs = lazy(() => import("@/pkg_market/settleUs/index"))

const marketRouter: RouteObject[] = [
  {
    path: "/settleUs",
    element: <SettleUs />,
  },
]

export default marketRouter
